module.exports = __webpack_public_path__ + "static/media/S4N3.ea0e4436.svg";